/* eslint-disable no-restricted-imports */
import { createSingleton } from '@luna/utils';

export type { Locale } from 'date-fns';

const localeSingleton = createSingleton<Locale | undefined>(undefined);

export const getCurrentLocale = (): Locale | undefined => localeSingleton.get();
export const dangerouslySetCurrentLocale = (locale?: Locale): void => localeSingleton.set(locale);
